import * as Bowser from "bowser";
import supportedBrowsers from "../config/supportedBrowsers";
var BrowserSupportService = (function () {
    function BrowserSupportService() {
    }
    BrowserSupportService.isSupported = function (supported) {
        if (supported === void 0) { supported = supportedBrowsers; }
        var userAgent = window.navigator.userAgent;
        var browser = Bowser.getParser(userAgent);
        var isSupported = browser.satisfies(supported);
        if (browser.isBrowser('ie')) {
            return false;
        }
        if (isSupported === undefined) {
            console.debug("BrowserSupportService: Unable to determine browser support according to User-Agent '%s', so assuming supported.", userAgent);
            return true;
        }
        return isSupported;
    };
    BrowserSupportService.canTouch = function () {
        return !!("ontouchstart" in window || navigator.msMaxTouchPoints);
    };
    BrowserSupportService.supportsApplePay = function () {
        var _a, _b;
        return (_b = (_a = window.ApplePaySession) === null || _a === void 0 ? void 0 : _a.canMakePayments()) !== null && _b !== void 0 ? _b : false;
    };
    return BrowserSupportService;
}());
export default BrowserSupportService;
//# sourceMappingURL=BrowserSupportService.js.map